import { SidePanelLayerOrGroup, ToolName, ToolNameToLayerType } from "@nova/constants"
import { selectHotspotMultiSelectFlight } from "features/data-management/hotspots/selectors"
import { useAppSelector } from "integrations/redux/hooks"
import { selectEntityById } from "panels/content/side-panel/slice"
import { selectLastSelectedLayerId } from "panels/content/side-panel/slice.new"
import { getInspectorPanelPlugins } from "plugins/plugin-registry"
import { selectActiveToolName } from "plugins/Toolbox/tool-registry"
import { useMemo } from "react"

export const useInspectorPanel = () => {
    const inspectorPanelPlugins = getInspectorPanelPlugins()
    const activeTool = useAppSelector(selectActiveToolName())
    const lastSelectedLayerId = useAppSelector(selectLastSelectedLayerId)
    const lastSelectedEntity = useAppSelector(selectEntityById(lastSelectedLayerId || "")) as
        | SidePanelLayerOrGroup
        | undefined
    const hotspotMultiSelectFlightId = useAppSelector(selectHotspotMultiSelectFlight)
    const hotspotMultiSelectFlight = useAppSelector(selectEntityById(hotspotMultiSelectFlightId))
    const pluginAndEntityData = useMemo(() => {
        if (
            activeTool &&
            activeTool !== ToolName.FirePerimeter &&
            activeTool !== ToolName.OrthoMask
        ) {
            return {
                plugin: inspectorPanelPlugins.find(
                    (plugin) => plugin.sidePanelLayerType === ToolNameToLayerType[activeTool]
                ),
                entityId: undefined,
            }
        } else if (lastSelectedLayerId) {
            return {
                plugin: inspectorPanelPlugins.find(
                    (plugin) => plugin.sidePanelLayerType === lastSelectedEntity?.type
                ),
                entityId: lastSelectedEntity?.id,
            }
        } else if (hotspotMultiSelectFlight) {
            return {
                plugin: inspectorPanelPlugins.find(
                    (plugin) => plugin.sidePanelLayerType === hotspotMultiSelectFlight.type
                ),
                entityId: hotspotMultiSelectFlightId,
            }
        } else {
            return {
                plugin: undefined,
                entityId: undefined,
            }
        }
    }, [
        activeTool,
        hotspotMultiSelectFlight,
        hotspotMultiSelectFlightId,
        inspectorPanelPlugins,
        lastSelectedEntity?.id,
        lastSelectedEntity?.type,
        lastSelectedLayerId,
    ])
    return pluginAndEntityData
}

export type InspectorPanelPlugin = NonNullable<ReturnType<typeof useInspectorPanel>["plugin"]>
